var _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg33(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#7b829d",
    height: "64px",
    width: "64px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 488.223 488.223",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M416.164,95.379l-90.33-88.79C321.538,2.366,315.756,0,309.732,0H105.171c-22.08,0-39.979,17.899-39.979,39.979v405.183 c0,11.504,4.479,22.322,12.635,30.487c8.152,8.106,18.982,12.573,30.427,12.573h270.913c23.754,0,43.059-19.319,43.059-43.075 l0.807-333.332C423.046,105.636,420.57,99.711,416.164,95.379z M329.293,57.75l34.509,34.16h-25.479 c-4.978,0-9.029-4.052-9.029-9.046V57.75z M388.192,445.147c0,4.994-4.032,9.046-9.026,9.046H108.253 c-2.411,0-4.711-0.972-6.418-2.665c-1.687-1.675-2.618-3.942-2.618-6.366V43.058c0-4.975,4.056-9.029,9.036-9.029h187.009v48.836 c0,23.754,19.325,43.075,43.061,43.075h49.87V445.147z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M233.92,193.186c-2.186-7.02-8.666-11.791-16.016-11.791h-20.056c-7.338,0-13.88,4.805-16.003,11.855l-35.895,117.471 c-1.566,5.057-0.607,10.592,2.551,14.853c3.143,4.256,8.15,6.777,13.463,6.777c7.533,0,14.119-5.009,16.131-12.252l7.37-26.499 h43.235l8.042,26.832c2.137,7.087,8.664,11.919,16.065,11.919h1.516c5.327,0,10.34-2.521,13.48-6.797 c3.178-4.275,4.118-9.828,2.537-14.914L233.92,193.186z M190.362,268.074l8.984-32.037c2.441-8.743,4.69-20.15,6.938-29.099h0.431 c2.25,8.948,4.945,20.149,7.63,29.099l9.41,32.037H190.362z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.437,181.38c-9.444,0-17.113,7.675-17.113,17.12v116.733c0,9.446,7.669,17.118,17.113,17.118 c9.463,0,17.152-7.672,17.152-17.118V198.5C331.589,189.055,323.899,181.38,314.437,181.38z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg33);
export default __webpack_public_path__ + "static/media/33.29a917fd030ec59320a3c14097614868.svg";
export { ForwardRef as ReactComponent };